export default "__VITE_ASSET__ByY7M5kd__"